export const actionTypes = {
  SET_EMP_LEAVES: "SET_EMP_LEAVES",
  CLEAR_MONTHLY_EMP_LEAVES: "CLEAR_MONTHLY_EMP_LEAVES",
  CLEAR_YEARLY_EMP_LEAVES: "CLEAR_YEARLY_EMP_LEAVES",
  LOADING: "LOADING",
  EMP_YEAR_LEAVES_LOADING: "EMP_YEAR_LEAVES_LOADING",
  GET_EMP_MONTH_LEAVES: "GET_EMP_MONTH_LEAVES",
  APPEND_EMP_MONTH_LEAVES: "APPEND_EMP_MONTH_LEAVES",
  SET_EMP_LEAVES_PAGINATION: "SET_EMP_LEAVES_PAGINATION",
  SHOW_ERROR: "SHOW_ERROR",
  LOADING_SHOW: "LOADING_SHOW",
  LOADING_HIDE: "LOADING_HIDE",
  BOOK_EMPLOYEE_TIMEOFF: "BOOK_EMPLOYEE_TIMEOFF",
  FETCH_LEAVE_TYPES: "FETCH_LEAVE_TYPES",
  CLEAR_TIME_OFF_MODAL: "CLEAR_TIME_OFF_MODAL",
  MERGE_LEAVE_UPDATES: "MERGE_LEAVE_UPDATES",
  // Validation action types
  SET_VALIDATION_LOADING: "SET_VALIDATION_LOADING",
  SET_VALIDATION_RESULT: "SET_VALIDATION_RESULT",
  CLEAR_VALIDATION_RESULT: "CLEAR_VALIDATION_RESULT"
};
